"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMortgageInsuranceTableCounterCycleWithProperty = exports.defaultMortgageInsuranceTableCounterCycle = exports.defaultMortgageInsuranceTableWithProperty = exports.defaultMortgageInsuranceTable = exports.defaultMortgageInsuranceTableAssholeBallShuWithProperty = exports.defaultMortgageInsuranceTableBitchCarrieLamWithProperty = exports.defaultMortgageInsuranceTableAssholeBallShu = exports.defaultMortgageInsuranceTableBitchCarrieLam = exports.defaultMortgageInsuranceTableOldWithProperty = exports.defaultMortgageInsuranceCounterCycle = exports.defaultMortgageInsuranceCounterCycleWithProperty = exports.defaultMortgageInsuranceTableOld = exports.defaultMortgageInsuranceTableInfinity = exports.defaultMortgageInsuranceTableTraditionBankWithProperty = exports.defaultMortgageInsuranceTableTraditionalBankCounterCycleWithProperty = exports.defaultMortgageInsuranceTableTraditionalBankCounterCycle = exports.defaultMortgageInsuranceTableTraditionBank = exports.defaultCounterCycleTable10_80 = exports.defaultCounterCycleTable10_75 = exports.defaultCounterCycleTable10_70 = exports.defaultCounterCycleTable10_65 = exports.defaultCounterCycleTable10_60 = exports.defaultCounterCycleTable8_80 = exports.defaultCounterCycleTable8_75 = exports.defaultCounterCycleTable8_70 = exports.defaultCounterCycleTable8_65 = exports.defaultCounterCycleTable6_80 = exports.defaultCounterCycleTable6_75 = exports.defaultCounterCycleTable6_70 = exports.defaultCounterCycleTable6_65 = exports.defaultCounterCycleTable9_80 = exports.defaultCounterCycleTable9_75 = exports.defaultCounterCycleTable9_70 = exports.defaultCounterCycleTable7_90 = exports.defaultCounterCycleTable7_85 = exports.defaultCounterCycleTable7_80 = exports.defaultCounterCycleTable7_75 = exports.defaultCounterCycleTable7_70 = exports.defaultCounterCycleTable7_65 = exports.defaultCounterCycleTable3_90 = exports.defaultCounterCycleTable3_85 = exports.defaultCounterCycleTable3_80 = exports.defaultCounterCycleTable3_75 = exports.defaultCounterCycleTable1_90 = exports.defaultCounterCycleTable1_85 = exports.defaultCounterCycleTable1_80 = exports.defaultCounterCycleTable1_75 = exports.defaultTable5_80 = exports.defaultTable5_70 = exports.defaultTable5_60 = exports.defaultTable5_50 = exports.defaultTable4_90 = exports.defaultTable4_85 = exports.defaultTable4_80 = exports.defaultTable3_90 = exports.defaultTable3_85 = exports.defaultTable3_80 = exports.defaultTable2_80 = exports.defaultTable1_90 = exports.defaultTable1_85 = exports.defaultTable1_80 = void 0;
exports.defaultTable1_80 = {
    key: 80,
    value: [
        {
            key: 10,
            value: 1.15
        },
        {
            key: 15,
            value: 1.5
        },
        {
            key: 20,
            value: 1.85
        },
        {
            key: 25,
            value: 2
        },
        {
            key: 30,
            value: 2.15
        }
    ]
};
exports.defaultTable1_85 = {
    key: 85,
    value: [
        {
            key: 10,
            value: 1.8
        },
        {
            key: 15,
            value: 2.28
        },
        {
            key: 20,
            value: 2.68
        },
        {
            key: 25,
            value: 2.95
        },
        {
            key: 30,
            value: 3.05
        }
    ]
};
exports.defaultTable1_90 = {
    key: 90,
    value: [
        {
            key: 10,
            value: 2.6
        },
        {
            key: 15,
            value: 3.18
        },
        {
            key: 20,
            value: 3.75
        },
        {
            key: 25,
            value: 4.1
        },
        {
            key: 30,
            value: 4.35
        }
    ]
};
exports.defaultTable2_80 = {
    key: 80,
    value: [
        {
            key: 10,
            value: 1.2
        },
        {
            key: 15,
            value: 1.68
        },
        {
            key: 20,
            value: 2.05
        },
        {
            key: 25,
            value: 2.28
        },
        {
            key: 30,
            value: 2.45
        }
    ]
};
exports.defaultTable3_80 = {
    key: 80,
    value: [
        {
            key: 10,
            value: 1.32
        },
        {
            key: 15,
            value: 1.73
        },
        {
            key: 20,
            value: 2.13
        },
        {
            key: 25,
            value: 2.3
        },
        {
            key: 30,
            value: 2.47
        }
    ]
};
exports.defaultTable3_85 = {
    key: 85,
    value: [
        {
            key: 10,
            value: 2.07
        },
        {
            key: 15,
            value: 2.62
        },
        {
            key: 20,
            value: 3.08
        },
        {
            key: 25,
            value: 3.39
        },
        {
            key: 30,
            value: 3.51
        }
    ]
};
exports.defaultTable3_90 = {
    key: 90,
    value: [
        {
            key: 10,
            value: 2.99
        },
        {
            key: 15,
            value: 3.66
        },
        {
            key: 20,
            value: 4.31
        },
        {
            key: 25,
            value: 4.72
        },
        {
            key: 30,
            value: 5
        }
    ]
};
exports.defaultTable4_80 = {
    key: 80,
    value: [
        {
            key: 10,
            value: 1.38
        },
        {
            key: 15,
            value: 1.93
        },
        {
            key: 20,
            value: 2.36
        },
        {
            key: 25,
            value: 2.62
        },
        {
            key: 30,
            value: 2.82
        }
    ]
};
exports.defaultTable4_85 = {
    key: 85,
    value: [
        {
            key: 10,
            value: 2.16
        },
        {
            key: 15,
            value: 2.85
        },
        {
            key: 20,
            value: 3.34
        },
        {
            key: 25,
            value: 3.66
        },
        {
            key: 30,
            value: 3.85
        }
    ]
};
exports.defaultTable4_90 = {
    key: 90,
    value: [
        {
            key: 10,
            value: 3.22
        },
        {
            key: 15,
            value: 4.03
        },
        {
            key: 20,
            value: 4.60
        },
        {
            key: 25,
            value: 5.04
        },
        {
            key: 30,
            value: 5.29
        }
    ]
};
exports.defaultTable5_50 = {
    key: 50,
    value: [
        {
            key: 10,
            value: 0.31
        },
        {
            key: 15,
            value: 0.44
        },
        {
            key: 20,
            value: 0.59
        },
        {
            key: 25,
            value: 0.70
        },
        {
            key: 30,
            value: 0.80
        }
    ]
};
exports.defaultTable5_60 = {
    key: 60,
    value: [
        {
            key: 10,
            value: 0.75
        },
        {
            key: 15,
            value: 1.04
        },
        {
            key: 20,
            value: 1.38
        },
        {
            key: 25,
            value: 1.61
        },
        {
            key: 30,
            value: 1.84
        }
    ]
};
exports.defaultTable5_70 = {
    key: 70,
    value: [
        {
            key: 10,
            value: 1.04
        },
        {
            key: 15,
            value: 1.44
        },
        {
            key: 20,
            value: 1.78
        },
        {
            key: 25,
            value: 2.01
        },
        {
            key: 30,
            value: 2.24
        }
    ]
};
exports.defaultTable5_80 = {
    key: 80,
    value: [
        {
            key: 10,
            value: 1.38
        },
        {
            key: 15,
            value: 1.93
        },
        {
            key: 20,
            value: 2.36
        },
        {
            key: 25,
            value: 2.62
        },
        {
            key: 30,
            value: 2.82
        }
    ]
};
exports.defaultCounterCycleTable1_75 = {
    key: 75,
    value: [
        {
            key: 10,
            value: 0
        },
        {
            key: 15,
            value: 0
        },
        {
            key: 20,
            value: 0
        },
        {
            key: 25,
            value: 0
        },
        {
            key: 30,
            value: 0
        }
    ]
};
exports.defaultCounterCycleTable1_80 = {
    key: 80,
    value: [
        {
            key: 10,
            value: 0.5
        },
        {
            key: 15,
            value: 0.6
        },
        {
            key: 20,
            value: 0.76
        },
        {
            key: 25,
            value: 0.83
        },
        {
            key: 30,
            value: 0.92
        }
    ]
};
exports.defaultCounterCycleTable1_85 = {
    key: 85,
    value: [
        {
            key: 10,
            value: 0.86
        },
        {
            key: 15,
            value: 1.02
        },
        {
            key: 20,
            value: 1.25
        },
        {
            key: 25,
            value: 1.35
        },
        {
            key: 30,
            value: 1.41
        }
    ]
};
exports.defaultCounterCycleTable1_90 = {
    key: 90,
    value: [
        {
            key: 10,
            value: 1.25
        },
        {
            key: 15,
            value: 1.48
        },
        {
            key: 20,
            value: 1.79
        },
        {
            key: 25,
            value: 2.03
        },
        {
            key: 30,
            value: 2.16
        }
    ]
};
exports.defaultCounterCycleTable3_75 = {
    key: 75,
    value: [
        {
            key: 10,
            value: 0
        },
        {
            key: 15,
            value: 0
        },
        {
            key: 20,
            value: 0
        },
        {
            key: 25,
            value: 0
        },
        {
            key: 30,
            value: 0
        }
    ]
};
exports.defaultCounterCycleTable3_80 = {
    key: 80,
    value: [
        {
            key: 10,
            value: 0.6
        },
        {
            key: 15,
            value: 0.71
        },
        {
            key: 20,
            value: 0.9
        },
        {
            key: 25,
            value: 0.97
        },
        {
            key: 30,
            value: 1.09
        }
    ]
};
exports.defaultCounterCycleTable3_85 = {
    key: 85,
    value: [
        {
            key: 10,
            value: 1.01
        },
        {
            key: 15,
            value: 1.2
        },
        {
            key: 20,
            value: 1.46
        },
        {
            key: 25,
            value: 1.57
        },
        {
            key: 30,
            value: 1.64
        }
    ]
};
exports.defaultCounterCycleTable3_90 = {
    key: 90,
    value: [
        {
            key: 10,
            value: 1.46
        },
        {
            key: 15,
            value: 1.72
        },
        {
            key: 20,
            value: 2.08
        },
        {
            key: 25,
            value: 2.35
        },
        {
            key: 30,
            value: 2.5
        }
    ]
};
exports.defaultCounterCycleTable7_65 = {
    key: 65,
    value: [
        {
            key: 10,
            value: 0
        },
        {
            key: 15,
            value: 0
        },
        {
            key: 20,
            value: 0
        },
        {
            key: 25,
            value: 0
        },
        {
            key: 30,
            value: 0
        }
    ]
};
exports.defaultCounterCycleTable7_70 = {
    key: 65,
    value: [
        {
            key: 10,
            value: 0.15
        },
        {
            key: 15,
            value: 0.15
        },
        {
            key: 20,
            value: 0.15
        },
        {
            key: 25,
            value: 0.15
        },
        {
            key: 30,
            value: 0.15
        }
    ]
};
exports.defaultCounterCycleTable7_75 = {
    key: 75,
    value: [
        {
            key: 10,
            value: 0.3
        },
        {
            key: 15,
            value: 0.3
        },
        {
            key: 20,
            value: 0.3
        },
        {
            key: 25,
            value: 0.3
        },
        {
            key: 30,
            value: 0.3
        }
    ]
};
exports.defaultCounterCycleTable7_80 = {
    key: 80,
    value: [
        {
            key: 10,
            value: 0.71
        },
        {
            key: 15,
            value: 0.97
        },
        {
            key: 20,
            value: 1.23
        },
        {
            key: 25,
            value: 1.35
        },
        {
            key: 30,
            value: 1.46
        }
    ]
};
exports.defaultCounterCycleTable7_85 = {
    key: 85,
    value: [
        {
            key: 10,
            value: 1.2
        },
        {
            key: 15,
            value: 1.55
        },
        {
            key: 20,
            value: 1.85
        },
        {
            key: 25,
            value: 2.05
        },
        {
            key: 30,
            value: 2.13
        }
    ]
};
exports.defaultCounterCycleTable7_90 = {
    key: 90,
    value: [
        {
            key: 10,
            value: 1.79
        },
        {
            key: 15,
            value: 2.23
        },
        {
            key: 20,
            value: 2.65
        },
        {
            key: 25,
            value: 2.92
        },
        {
            key: 30,
            value: 3.1
        }
    ]
};
exports.defaultCounterCycleTable9_70 = {
    key: 70,
    value: [
        {
            key: 10,
            value: 0.3
        },
        {
            key: 15,
            value: 0.3
        },
        {
            key: 20,
            value: 0.3
        },
        {
            key: 25,
            value: 0.3
        },
        {
            key: 30,
            value: 0.3
        }
    ]
};
exports.defaultCounterCycleTable9_75 = {
    key: 75,
    value: [
        {
            key: 10,
            value: 0.45
        },
        {
            key: 15,
            value: 0.45
        },
        {
            key: 20,
            value: 0.45
        },
        {
            key: 25,
            value: 0.45
        },
        {
            key: 30,
            value: 0.45
        }
    ]
};
exports.defaultCounterCycleTable9_80 = {
    key: 80,
    value: [
        {
            key: 10,
            value: 0.86
        },
        {
            key: 15,
            value: 1.12
        },
        {
            key: 20,
            value: 1.38
        },
        {
            key: 25,
            value: 1.5
        },
        {
            key: 30,
            value: 1.61
        }
    ]
};
exports.defaultCounterCycleTable6_65 = {
    key: 65,
    value: [
        {
            key: 10,
            value: 0.15
        },
        {
            key: 15,
            value: 0.15
        },
        {
            key: 20,
            value: 0.15
        },
        {
            key: 25,
            value: 0.15
        },
        {
            key: 30,
            value: 0.15
        }
    ]
};
exports.defaultCounterCycleTable6_70 = {
    key: 70,
    value: [
        {
            key: 10,
            value: 0.3
        },
        {
            key: 15,
            value: 0.3
        },
        {
            key: 20,
            value: 0.3
        },
        {
            key: 25,
            value: 0.3
        },
        {
            key: 30,
            value: 0.3
        }
    ]
};
exports.defaultCounterCycleTable6_75 = {
    key: 75,
    value: [
        {
            key: 10,
            value: 0.45
        },
        {
            key: 15,
            value: 0.45
        },
        {
            key: 20,
            value: 0.45
        },
        {
            key: 25,
            value: 0.45
        },
        {
            key: 30,
            value: 0.45
        }
    ]
};
exports.defaultCounterCycleTable6_80 = {
    key: 80,
    value: [
        {
            key: 10,
            value: 0.75
        },
        {
            key: 15,
            value: 0.98
        },
        {
            key: 20,
            value: 1.2
        },
        {
            key: 25,
            value: 1.3
        },
        {
            key: 30,
            value: 1.4
        }
    ]
};
exports.defaultCounterCycleTable8_65 = {
    key: 65,
    value: [
        {
            key: 10,
            value: 0.15
        },
        {
            key: 15,
            value: 0.15
        },
        {
            key: 20,
            value: 0.15
        },
        {
            key: 25,
            value: 0.15
        },
        {
            key: 30,
            value: 0.15
        }
    ]
};
exports.defaultCounterCycleTable8_70 = {
    key: 70,
    value: [
        {
            key: 10,
            value: 0.3
        },
        {
            key: 15,
            value: 0.3
        },
        {
            key: 20,
            value: 0.3
        },
        {
            key: 25,
            value: 0.3
        },
        {
            key: 30,
            value: 0.3
        }
    ]
};
exports.defaultCounterCycleTable8_75 = {
    key: 75,
    value: [
        {
            key: 10,
            value: 0.45
        },
        {
            key: 15,
            value: 0.45
        },
        {
            key: 20,
            value: 0.45
        },
        {
            key: 25,
            value: 0.45
        },
        {
            key: 30,
            value: 0.45
        }
    ]
};
exports.defaultCounterCycleTable8_80 = {
    key: 80,
    value: [
        {
            key: 10,
            value: 0.86
        },
        {
            key: 15,
            value: 1.12
        },
        {
            key: 20,
            value: 1.38
        },
        {
            key: 25,
            value: 1.5
        },
        {
            key: 30,
            value: 1.61
        }
    ]
};
exports.defaultCounterCycleTable10_60 = {
    key: 60,
    value: [
        {
            key: 10,
            value: 0.3
        },
        {
            key: 15,
            value: 0.3
        },
        {
            key: 20,
            value: 0.3
        },
        {
            key: 25,
            value: 0.3
        },
        {
            key: 30,
            value: 0.3
        }
    ]
};
exports.defaultCounterCycleTable10_65 = {
    key: 65,
    value: [
        {
            key: 10,
            value: 0.45
        },
        {
            key: 15,
            value: 0.45
        },
        {
            key: 20,
            value: 0.45
        },
        {
            key: 25,
            value: 0.45
        },
        {
            key: 30,
            value: 0.45
        }
    ]
};
exports.defaultCounterCycleTable10_70 = {
    key: 70,
    value: [
        {
            key: 10,
            value: 0.6
        },
        {
            key: 15,
            value: 0.6
        },
        {
            key: 20,
            value: 0.6
        },
        {
            key: 25,
            value: 0.6
        },
        {
            key: 30,
            value: 0.6
        }
    ]
};
exports.defaultCounterCycleTable10_75 = {
    key: 75,
    value: [
        {
            key: 10,
            value: 0.75
        },
        {
            key: 15,
            value: 0.75
        },
        {
            key: 20,
            value: 0.75
        },
        {
            key: 25,
            value: 0.75
        },
        {
            key: 30,
            value: 0.75
        }
    ]
};
exports.defaultCounterCycleTable10_80 = {
    key: 80,
    value: [
        {
            key: 10,
            value: 0.9
        },
        {
            key: 15,
            value: 1.25
        },
        {
            key: 20,
            value: 1.53
        },
        {
            key: 25,
            value: 1.7
        },
        {
            key: 30,
            value: 1.83
        }
    ]
};
exports.defaultMortgageInsuranceTableTraditionBank = [
    {
        minPropertyValue: 0,
        maxPropertyValue: 9999999,
        basicLoanCap: 60,
        maxLoanAmount: 5000000,
        rate: []
    },
    {
        minPropertyValue: 9999999,
        maxPropertyValue: Number.MAX_SAFE_INTEGER,
        basicLoanCap: 50,
        rate: []
    }
];
exports.defaultMortgageInsuranceTableTraditionalBankCounterCycle = [
    {
        minPropertyValue: 0,
        maxPropertyValue: 17500000,
        basicLoanCap: 70,
        maxLoanAmount: 10500000,
        rate: []
    },
    {
        minPropertyValue: 17500001,
        maxPropertyValue: 36000000,
        basicLoanCap: 60,
        maxLoanAmount: 18000000,
        rate: []
    },
    {
        minPropertyValue: 36000001,
        maxPropertyValue: Number.MAX_SAFE_INTEGER,
        basicLoanCap: 50,
        rate: []
    }
];
exports.defaultMortgageInsuranceTableTraditionalBankCounterCycleWithProperty = [
    {
        minPropertyValue: 0,
        maxPropertyValue: 17500000,
        basicLoanCap: 60,
        maxLoanAmount: 9000000,
        rate: []
    },
    {
        minPropertyValue: 17500001,
        maxPropertyValue: 36000000,
        basicLoanCap: 50,
        maxLoanAmount: 14400000,
        rate: []
    },
    {
        minPropertyValue: 36000001,
        maxPropertyValue: Number.MAX_SAFE_INTEGER,
        basicLoanCap: 40,
        rate: []
    }
];
exports.defaultMortgageInsuranceTableTraditionBankWithProperty = [
    {
        minPropertyValue: 0,
        maxPropertyValue: 9999999,
        basicLoanCap: 50,
        maxLoanAmount: 5000000,
        rate: []
    },
    {
        minPropertyValue: 9999999,
        maxPropertyValue: Number.MAX_SAFE_INTEGER,
        basicLoanCap: 40,
        rate: []
    }
];
exports.defaultMortgageInsuranceTableInfinity = [
    {
        minPropertyValue: 9999999,
        maxPropertyValue: Number.MAX_SAFE_INTEGER,
        basicLoanCap: 50,
        rate: [{ key: 60, value: [{ key: 60, value: 0 }] }]
    }
];
exports.defaultMortgageInsuranceTableOld = [
    {
        minPropertyValue: 0,
        maxPropertyValue: 4000000,
        basicLoanCap: 60,
        rate: [exports.defaultTable1_80, exports.defaultTable1_85, exports.defaultTable1_90]
    },
    {
        minPropertyValue: 4000000,
        maxPropertyValue: 4499999,
        basicLoanCap: 60,
        maxLoanAmount: 36000000,
        rate: [exports.defaultTable1_80, exports.defaultTable1_85, exports.defaultTable1_90]
    },
    {
        minPropertyValue: 4499999,
        maxPropertyValue: 6000000,
        basicLoanCap: 60,
        maxLoanAmount: 48000000,
        rate: [exports.defaultTable1_80]
    }
];
exports.defaultMortgageInsuranceCounterCycleWithProperty = [
    {
        minPropertyValue: 0,
        maxPropertyValue: 6000000,
        basicLoanCap: 60,
        maxLoanAmount: 4800000,
        rate: [exports.defaultCounterCycleTable6_65, exports.defaultCounterCycleTable6_70, exports.defaultCounterCycleTable6_75, exports.defaultCounterCycleTable6_80]
    },
    {
        minPropertyValue: 6000000,
        maxPropertyValue: 10000000,
        basicLoanCap: 60,
        rate: [exports.defaultCounterCycleTable8_65, exports.defaultCounterCycleTable8_70, exports.defaultCounterCycleTable8_75, exports.defaultCounterCycleTable8_80]
    },
    {
        minPropertyValue: 10000001,
        maxPropertyValue: 11250000,
        basicLoanCap: 60,
        maxLoanAmount: 9000000,
        rate: [exports.defaultCounterCycleTable8_65, exports.defaultCounterCycleTable8_70, exports.defaultCounterCycleTable8_75, exports.defaultCounterCycleTable8_80]
    },
    {
        minPropertyValue: 11250001,
        maxPropertyValue: 15000000,
        basicLoanCap: 60,
        rate: [exports.defaultCounterCycleTable8_65, exports.defaultCounterCycleTable8_70, exports.defaultCounterCycleTable8_75, exports.defaultCounterCycleTable8_80]
    },
    {
        minPropertyValue: 15000001,
        maxPropertyValue: 17150000,
        basicLoanCap: 60,
        allowLoanAmount: 9000000,
        maxLoanAmount: 12000000,
        rate: [exports.defaultCounterCycleTable10_60, exports.defaultCounterCycleTable10_75, exports.defaultCounterCycleTable10_80]
    },
    {
        minPropertyValue: 17150001,
        maxPropertyValue: 17500000,
        basicLoanCap: 60,
        allowLoanAmount: 9000000,
        rate: [exports.defaultCounterCycleTable10_70]
    },
    {
        minPropertyValue: 17500001,
        maxPropertyValue: 30000000,
        basicLoanCap: 50,
        rate: [exports.defaultCounterCycleTable10_70]
    },
];
exports.defaultMortgageInsuranceCounterCycle = [
    {
        minPropertyValue: 0,
        maxPropertyValue: 4000000,
        basicLoanCap: 70,
        rate: [exports.defaultCounterCycleTable1_75, exports.defaultCounterCycleTable1_80, exports.defaultCounterCycleTable1_85, exports.defaultCounterCycleTable1_90]
    },
    {
        minPropertyValue: 4000000,
        maxPropertyValue: 6000000,
        basicLoanCap: 70,
        rate: [exports.defaultCounterCycleTable1_75, exports.defaultCounterCycleTable1_80, exports.defaultCounterCycleTable1_85, exports.defaultCounterCycleTable1_90]
    },
    {
        minPropertyValue: 6000000,
        maxPropertyValue: 10000000,
        basicLoanCap: 70,
        rate: [exports.defaultCounterCycleTable3_75, exports.defaultCounterCycleTable3_80, exports.defaultCounterCycleTable3_85, exports.defaultCounterCycleTable3_90]
    },
    {
        minPropertyValue: 10000001,
        maxPropertyValue: 11250000,
        basicLoanCap: 70,
        maxLoanAmount: 9000000,
        rate: [exports.defaultCounterCycleTable3_75, exports.defaultCounterCycleTable7_80, exports.defaultCounterCycleTable7_85, exports.defaultCounterCycleTable7_90]
    },
    {
        minPropertyValue: 11250001,
        maxPropertyValue: 15000000,
        basicLoanCap: 70,
        rate: [exports.defaultCounterCycleTable3_75, exports.defaultCounterCycleTable7_80]
    },
    {
        minPropertyValue: 15000001,
        maxPropertyValue: 17150000,
        basicLoanCap: 70,
        allowLoanAmount: 10500000,
        maxLoanAmount: 12000000,
        rate: [exports.defaultCounterCycleTable9_70, exports.defaultCounterCycleTable9_75, exports.defaultCounterCycleTable9_80]
    },
    {
        minPropertyValue: 17150001,
        maxPropertyValue: 17500000,
        basicLoanCap: 70,
        allowLoanAmount: 10500000,
        rate: [exports.defaultCounterCycleTable9_70]
    },
    {
        minPropertyValue: 17500001,
        maxPropertyValue: 30000000,
        basicLoanCap: 60,
        rate: [exports.defaultCounterCycleTable9_70]
    },
];
exports.defaultMortgageInsuranceTableOldWithProperty = [
    {
        minPropertyValue: 0,
        maxPropertyValue: 6000000,
        basicLoanCap: 50,
        rate: [exports.defaultTable2_80]
    }
];
exports.defaultMortgageInsuranceTableBitchCarrieLam = [
    {
        minPropertyValue: 0,
        maxPropertyValue: 8000000,
        basicLoanCap: 60,
        rate: [exports.defaultTable3_80, exports.defaultTable3_85, exports.defaultTable3_90]
    },
    {
        minPropertyValue: 7999999,
        maxPropertyValue: 8333333,
        basicLoanCap: 60,
        maxLoanAmount: 7200000,
        rate: [exports.defaultTable3_80, exports.defaultTable3_85, exports.defaultTable3_90]
    },
    {
        minPropertyValue: 8333333,
        maxPropertyValue: 8999999,
        basicLoanCap: 50,
        allowLoanAmount: 5000000,
        maxLoanAmount: 7200000,
        rate: [exports.defaultTable4_80, exports.defaultTable4_85, exports.defaultTable4_90]
    },
    {
        minPropertyValue: 8999999,
        maxPropertyValue: 10000000,
        basicLoanCap: 50,
        allowLoanAmount: 5000000,
        maxLoanAmount: 8000000,
        rate: [exports.defaultTable4_80]
    }
];
exports.defaultMortgageInsuranceTableAssholeBallShu = [
    {
        minPropertyValue: 0,
        maxPropertyValue: 8333333,
        basicLoanCap: 60,
        rate: [exports.defaultTable3_80, exports.defaultTable3_85, exports.defaultTable3_90]
    },
    {
        minPropertyValue: 8333333,
        maxPropertyValue: 10000000,
        basicLoanCap: 60,
        allowLoanAmount: 5000000,
        maxLoanAmount: 9000000,
        rate: [exports.defaultTable4_80, exports.defaultTable4_85, exports.defaultTable4_90]
    },
    {
        minPropertyValue: 10000000,
        maxPropertyValue: 11250000,
        basicLoanCap: 50,
        allowLoanAmount: 5000000,
        maxLoanAmount: 9000000,
        rate: [exports.defaultTable4_80, exports.defaultTable4_85, exports.defaultTable4_90]
    },
    {
        minPropertyValue: 11250000,
        maxPropertyValue: 12000000,
        basicLoanCap: 50,
        allowLoanAmount: 5000000,
        rate: [exports.defaultTable4_80]
    },
    {
        minPropertyValue: 12000000,
        maxPropertyValue: 19200000,
        basicLoanCap: 50,
        allowLoanAmount: 5000000,
        maxLoanAmount: 9600000,
        rate: [exports.defaultTable5_50, exports.defaultTable5_60, exports.defaultTable5_70, exports.defaultTable5_80]
    }
];
exports.defaultMortgageInsuranceTableBitchCarrieLamWithProperty = [
    {
        minPropertyValue: 4000000,
        maxPropertyValue: 8000000,
        basicLoanCap: 50,
        rate: [exports.defaultTable4_80]
    },
    {
        minPropertyValue: 7999999,
        maxPropertyValue: 8333333,
        basicLoanCap: 50,
        maxLoanAmount: 7200000,
        rate: [exports.defaultTable4_80]
    },
    {
        minPropertyValue: 8333333,
        maxPropertyValue: 8999999,
        basicLoanCap: 40,
        allowLoanAmount: 5000000,
        maxLoanAmount: 7200000,
        rate: [exports.defaultTable4_80]
    },
    {
        minPropertyValue: 8999999,
        maxPropertyValue: 10000000,
        basicLoanCap: 40,
        allowLoanAmount: 5000000,
        maxLoanAmount: 80000000,
        rate: [exports.defaultTable4_80]
    }
];
exports.defaultMortgageInsuranceTableAssholeBallShuWithProperty = [
    {
        minPropertyValue: 0,
        maxPropertyValue: 8333333,
        basicLoanCap: 50,
        rate: [exports.defaultTable4_80, exports.defaultTable4_85, exports.defaultTable4_90]
    },
    {
        minPropertyValue: 8333333,
        maxPropertyValue: 10000000,
        basicLoanCap: 40,
        allowLoanAmount: 5000000,
        maxLoanAmount: 9000000,
        rate: [exports.defaultTable4_80, exports.defaultTable4_85, exports.defaultTable4_90]
    },
    {
        minPropertyValue: 10000000,
        maxPropertyValue: 11250000,
        basicLoanCap: 40,
        allowLoanAmount: 5000000,
        maxLoanAmount: 9000000,
        rate: [exports.defaultTable4_80, exports.defaultTable4_85, exports.defaultTable4_90]
    },
    {
        minPropertyValue: 11250000,
        maxPropertyValue: 12000000,
        basicLoanCap: 40,
        allowLoanAmount: 5000000,
        rate: [exports.defaultTable4_80]
    },
    {
        minPropertyValue: 12000000,
        maxPropertyValue: 19200000,
        basicLoanCap: 40,
        allowLoanAmount: 5000000,
        maxLoanAmount: 9600000,
        rate: [exports.defaultTable5_50, exports.defaultTable5_60, exports.defaultTable5_70, exports.defaultTable5_80]
    }
];
exports.defaultMortgageInsuranceTable = [
    { plan: exports.defaultMortgageInsuranceTableTraditionBank },
    { plan: exports.defaultMortgageInsuranceTableOld },
    { plan: exports.defaultMortgageInsuranceTableAssholeBallShu }
];
exports.defaultMortgageInsuranceTableWithProperty = [
    { plan: exports.defaultMortgageInsuranceTableTraditionBankWithProperty },
    { plan: exports.defaultMortgageInsuranceTableOldWithProperty },
    { plan: exports.defaultMortgageInsuranceTableAssholeBallShuWithProperty }
];
exports.defaultMortgageInsuranceTableCounterCycle = [
    { plan: exports.defaultMortgageInsuranceTableTraditionalBankCounterCycle },
    { plan: exports.defaultMortgageInsuranceCounterCycle },
];
exports.defaultMortgageInsuranceTableCounterCycleWithProperty = [
    { plan: exports.defaultMortgageInsuranceTableTraditionalBankCounterCycleWithProperty },
    { plan: exports.defaultMortgageInsuranceCounterCycleWithProperty },
];
